<script setup>

import { defineProps, defineEmits, ref, watch} from "vue";
import BarraNavegacao from "./BarraNavegacao.vue";
import DadoConteudo from "./DadoConteudo.vue";
import UtilObject from "@/utils/UtilObject";
import UtilDateTime from "@/utils/UtilDateTime";
import JobService from "@/api/v2/services/JobService";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "controlesDesativados",
    "visualizandoDado",
    "dadoOriginal",
]);

const emits = defineEmits([
    "update:alteraDados",
    "update:alteraDado",
    "update:alteraControlesDesativados",
    "update:alteraVisualizandoDado",
]);

//==================================================================//
//============================= Dado ===============================//
//==================================================================//

const dado = ref({});

//==================================================================//
//===================== Datas Entrega Final ========================//
//==================================================================//

const editandoDatasEntregaFinal = ref(false);
const salvandoDatasEntregaFinal = ref(false);
const erroDatasEntregaFinal = ref("");

//==================================================================//
//=================== Altera Visualizando Dado =====================//
//==================================================================//

const alteraVisualizandoDado = (update = {}) =>{

    update.modal =  false;
    emits('update:alteraVisualizandoDado',update);

};

//==================================================================//
//==================== Altera Dado de Compra =======================//
//==================================================================//

const alteraDado = (update = {})=>{

    dado.value = UtilObject.merge(dado.value, update)

};

//==================================================================//
//========================= Altera Item ============================//
//==================================================================//

const alteraItem = (update) => {

    let itens = dado?.value?.itens?.map((item)=>{

        if(item.id != update.id){
            return item;
        }

        return UtilObject.merge(item,update);

    });

    alteraDado({
        itens: itens
    });

};

//==================================================================//
//======================== Altera Aditivo ==========================//
//==================================================================//

const alteraAditivo = (update) => {

    let aditivos = dado?.value?.aditivos?.map((aditivo)=>{

        if(aditivo.id != update.id){
            return aditivo;
        }

        return Object.merge(aditivo, update);

    });

    alteraDado({
        aditivos: aditivos
    });

};

//===================================================================//
//========================== Prepara Dado ===========================//
//=================================================-=================//

const preparaDado = (dado = {})=>{

    let itens = dado?.itens?.map((item)=>{

        let subItens = item?.itens?.map((subItem)=>{

            return{
                id: subItem?.id || "",
                codigo: subItem?.codigo || "",
                sequencia: subItem?.sequencia || "",
                descricao: subItem?.descricao || "",
                quantidade: subItem?.quantidade || 0,
                valorUnitario: subItem?.valorUnitario || 0,
                valorTotal: subItem?.valorTotal || 0,
            };

        });

        return{
            id: item?.id || "",
            aberto: false,
            codigo: item?.codigo || "",
            status: item?.status || "",
            sequencia: item?.sequencia || "",
            descricao: item?.descricao || "",
            dataPrazoEntrega: item?.dataPrazoEntrega || "",
            dataPrazoEntregaFormatada: item?.dataPrazoEntregaFormatada || "",
            quantidade: item?.quantidade || 0,
            precoUnitario: item?.precoUnitario || 0,
            precoTotal: item?.precoTotal || 0,
            valorBaseICMS_ISS: item?.valorBaseICMS_ISS || 0,
            porcentagemICMS: item?.porcentagemICMS || 0,
            valorICMS: item?.valorICMS || 0,
            porcentagemIPI: item?.porcentagemIPI || 0,
            valorIPI: item?.valorIPI || 0,
            porcentagemISS: item?.porcentagemISS || 0,
            valorISS: item?.valorISS || 0,
            ncm: item?.ncm || {},
            //tipoDeEquipamento: item?.tipoDeEquipamento || {},
            tipoDeEquipamentoID: item?.tipoDeEquipamento?.id || "",
            tipoDeEquipamentoCodigo: item?.tipoDeEquipamento?.codigo || "",
            tipoDeEquipamentoDescricao: item?.tipoDeEquipamento?.descricao || "",
            itens: subItens || [],
            itensQuantidade: item?.itensQuantidade || 0,
        }

    });

    let aditivos = dado?.aditivos?.map((aditivo)=>{

        return{
            id: aditivo?.id || "",
            codigo: aditivo?.codigo || "",
            descricao: aditivo?.descricao || "",
            valorAdicional: aditivo?.valorAdicional || 0,
        }

    });

    dado = {
        id: dado?.id || "",
        status: dado?.status || "",
        codigo: dado?.codigo || "",
        jobTipo: dado?.jobTipo || "",
        
        valorDeCusto: dado?.valorDeCusto || 0,
        valorDeVenda: dado?.valorDeVenda || 0,
        valorDeVendaComImpostos: dado?.valorDeVendaComImpostos || 0,

        descricao: dado?.descricao || "",
        condicaoDePagamento: dado?.condicaoDePagamento || "",
        justificativaDeCancelamento: dado?.justificativaDeCancelamento || "",
        observacao: dado?.observacao || "",

        dataAbertura: dado?.dataAbertura || "",
        dataAberturaFormatada: dado?.dataAberturaFormatada || "",
        
        dataEntregaContratual: dado?.dataEntregaContratual || "",
        dataEntregaContratualFormatada: dado?.dataEntregaContratualFormatada || "",
        dataEncerramento: dado?.dataEncerramento || "",
        dataEncerramentoFormatada: dado?.dataEncerramentoFormatada || "",
        
        dataEnvioAprovacaoContratual: dado?.dataEnvioAprovacaoContratual || "",
        dataEnvioAprovacaoContratualFormatada: dado?.dataEnvioAprovacaoContratualFormatada || "",
        dataEnvioAprovacaoEfetiva: dado?.dataEnvioAprovacaoEfetiva || "",
        dataEnvioAprovacaoEfetivaFormatada: dado?.dataEnvioAprovacaoEfetivaFormatada || "",
        naoTemEnvioAprovacao: dado?.naoTemEnvioAprovacao || "",
        
        dataAprovacaoPrevista: dado?.dataAprovacaoPrevista || "",
        dataAprovacaoPrevistaFormatada: dado?.dataAprovacaoPrevistaFormatada || "",
        dataAprovacaoEfetiva: dado?.dataAprovacaoEfetiva || "",
        dataAprovacaoEfetivaFormatada: dado?.dataAprovacaoEfetivaFormatada || "",
        naoTemAprovacao: dado?.naoTemAprovacao || false,
       
        dataInspecaoPrevista: dado?.dataInspecaoPrevista || "",
        dataInspecaoPrevistaFormatada: dado?.dataInspecaoPrevistaFormatada || "",
        dataInspecaoEfetiva: dado?.dataInspecaoEfetiva || "",
        dataInspecaoEfetivaFormatada: dado?.dataInspecaoEfetivaFormatada || "",
        naoTemInspecao: dado?.naoTemInspecao || false,
        
        dataEntregaFiscalPrevista: dado?.dataEntregaFiscalPrevista || "",
        dataEntregaFiscalPrevistaFormatada: dado?.dataEntregaFiscalPrevistaFormatada || "",
        dataEntregaFiscalEfetiva: dado?.dataEntregaFiscalEfetiva || "",
        dataEntregaFiscalEfetivaFormatada: dado?.dataEntregaFiscalEfetivaFormatada || "",
        naoTemEntregaFiscal: dado?.naoTemEntregaFiscal || false,
        
        dataMontagemContratual: dado?.dataMontagemContratual || "",
        dataMontagemContratualFormatada: dado?.dataMontagemContratualFormatada || "",
        dataMontagemEfetiva: dado?.dataMontagemEfetiva || "",
        dataMontagemEfetivaFormatada: dado?.dataMontagemEfetivaFormatada || "",
        naoTemMontagem: dado?.naoTemMontagem || false,

        dataStartupPrevista: dado?.dataStartupPrevista || "",
        dataStartupPrevistaFormatada: dado?.dataStartupPrevistaFormatada || "",
        dataStartupEfetiva: dado?.dataStartupEfetiva || "",
        dataStartupEfetivaFormatada: dado?.dataStartupEfetivaFormatada || "",
        naoTemStartup: dado?.naoTemStartup || false,

        dataFinalContratual: dado?.dataFinalContratual || "",
        dataFinalContratualFormatada: dado?.dataFinalContratualFormatada || "",
        dataFinalEfetiva: dado?.dataFinalEfetiva || "",
        dataFinalEfetivaFormatada: dado?.dataFinalEfetivaFormatada || "",

        solicitacaoDeOrcamento: dado?.solicitacaoDeOrcamento || {},
        solicitacaoDeOrcamentoID: dado?.solicitacaoDeOrcamento?.id || "",
        solicitacaoDeOrcamentoCodigo: dado?.solicitacaoDeOrcamento?.codigo || "",
        solicitacaoDeOrcamentoValor: dado?.solicitacaoDeOrcamento?.valor || "",

        //solicitacaoDeOrcamentoTipoDeEquipamento: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento || "",
        solicitacaoDeOrcamentoTipoDeEquipamentoID: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.id || "",
        solicitacaoDeOrcamentoTipoDeEquipamentoSigla: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.sigla || "",
        solicitacaoDeOrcamentoTipoDeEquipamentoDescricao: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.descricao || "",

        //solicitacaoDeOrcamentoContatoComercial: dado?.solicitacaoDeOrcamento?.contatoComercial || {},
        solicitacaoDeOrcamentoContatoComercialID: dado?.solicitacaoDeOrcamento?.contatoComercial?.id || "",
        solicitacaoDeOrcamentoContatoComercialTipo: dado?.solicitacaoDeOrcamento?.contatoComercial?.tipo || "",
        solicitacaoDeOrcamentoContatoComercialNome: dado?.solicitacaoDeOrcamento?.contatoComercial?.nome || "",

        //solicitacaoDeOrcamentoContatoTecnico: dado?.solicitacaoDeOrcamento?.contatoTecnico || {},
        solicitacaoDeOrcamentoContatoTecnicoID: dado?.solicitacaoDeOrcamento?.contatoTecnico?.id || "",
        solicitacaoDeOrcamentoContatoTecnicoTipo: dado?.solicitacaoDeOrcamento?.contatoTecnico?.tipo || "",
        solicitacaoDeOrcamentoContatoTecnicoNome: dado?.solicitacaoDeOrcamento?.contatoTecnico?.nome || "",

        cliente: dado?.cliente || {},
        clienteID: dado?.cliente?.id || "",
        clienteCodigo: dado?.cliente?.codigo || "",
        clienteNome: dado?.cliente?.nomeFantasia || "",
        clientePedidoDeCompra: dado?.clientePedidoDeCompra || "",
        clienteEmailXML: dado?.clienteEmailXML || "",

        //comercial : dado?.comercial || {},
        comercialID: dado?.comercial?.id || "",
        comercialCodigo: dado?.comercial?.codigo || "",
        comercialNome: dado?.comercial?.nome || "",

        //gestor: dado?.gestorDeContratos || {},
        gestorID: dado?.gestorDeContratos?.id || "",
        gestorCodigo: dado?.gestorDeContratos?.codigo || "",
        gestorNome: dado?.gestorDeContratos?.nome || "",

        //coordenador: dado?.coordenadorDeContratos || {},
        coordenadorID: dado?.coordenadorDeContratos?.id || "",
        coordenadorCodigo: dado?.coordenadorDeContratos?.codigo || "",
        coordenadorNome: dado?.coordenadorDeContratos?.nome || "",

        //ncm: dado?.ncm || {},
        ncmID: dado?.ncm?.id || "",
        ncmCodigo: dado?.ncm?.codigo || "",
        ncmDescricao: dado?.ncm?.descricao || "",
        ncmDescricaoCompleta: dado?.ncm?.descricaoCompleta || "",

        //transporte: dado?.transporte || {},
        transporteID: dado?.transporte?.id || "",
        transporteCodigo: dado?.transporte?.codigo || "",
        transporteOrdem: dado?.transporte?.ordem || "",
        transporteSigla: dado?.transporte?.sigla || "",
        transporteDescricao: dado?.transporte?.descricao || "",
        transporteDescricaoCompleta: dado?.transporte?.descricaoCompleta || "",

        itens: itens || [],
        itensQuantidade: dado?.itensQuantidade || 0,

        aditivos: aditivos || [],
        aditivosQuantidade : dado?.aditivosQuantidade || 0,
    }

    alteraDado(dado);

};

//==================================================================//
//======================== Prepara Modal ===========================//
//==================================================================//

const preparaModal = async ()=>{

    preparaDado(UtilObject.clone(props?.dadoOriginal));

    editandoDatasEntregaFinal.value = false;
    salvandoDatasEntregaFinal.value = false;
    erroDatasEntregaFinal.value = "";

}

//==================================================================//
//=================== Inicia Edição Datas Final ====================//
//==================================================================//

const iniciaEdicaoDatasEntregaFinal = () => {

    editandoDatasEntregaFinal.value = true;
    erroDatasEntregaFinal.value = "";

};

//==================================================================//
//=================== Cancela Edição Datas Final ===================//
//==================================================================//

const cancelaEdicaoDatasEntregaFinal = () => {

    editandoDatasEntregaFinal.value = false;
    erroDatasEntregaFinal.value = "";

};

//==================================================================//
//===================== Salva Datas Entrega Final ==================//
//==================================================================//

const salvaDatasEntregaFinal = async (update = {}) => {

    try {

        erroDatasEntregaFinal.value = "";

        const dataFinalContratual = update?.dataFinalContratual || "";
        const dataFinalEfetiva = update?.dataFinalEfetiva || "";

        if (dataFinalContratual && UtilDateTime.isInvalid({ dateTime: dataFinalContratual })) {
            erroDatasEntregaFinal.value = "Data Contratual inválida. Use o formato dd/mm/aaaa.";
            return;
        }

        if (dataFinalEfetiva && UtilDateTime.isInvalid({ dateTime: dataFinalEfetiva })) {
            erroDatasEntregaFinal.value = "Data Efetiva inválida. Use o formato dd/mm/aaaa.";
            return;
        }

        salvandoDatasEntregaFinal.value = true;

        const dataFinalContratualUTC = dataFinalContratual ? UtilDateTime.toFormatUTC({ dateTime: dataFinalContratual }) : "";
        const dataFinalEfetivaUTC = dataFinalEfetiva ? UtilDateTime.toFormatUTC({ dateTime: dataFinalEfetiva }) : "";

        const payload = {
            ...dado.value,
            dataFinalContratual: dataFinalContratualUTC,
            dataFinalContratualFormatada: dataFinalContratual ? UtilDateTime.toFormatBrazil({ dateTime: dataFinalContratual }) : "",
            dataFinalEfetiva: dataFinalEfetivaUTC,
            dataFinalEfetivaFormatada: dataFinalEfetiva ? UtilDateTime.toFormatBrazil({ dateTime: dataFinalEfetiva }) : "",
        };

        const resposta = await JobService.salvarPreenchimentoDeCoordenador(payload);
        if (resposta?.status != 200) {
            erroDatasEntregaFinal.value = resposta?.message || "Não foi possível salvar as datas de entrega.";
            return;
        }

        alteraDado({
            dataFinalContratual: dataFinalContratualUTC,
            dataFinalContratualFormatada: dataFinalContratual ? UtilDateTime.toFormatBrazil({ dateTime: dataFinalContratual }) : "",
            dataFinalEfetiva: dataFinalEfetivaUTC,
            dataFinalEfetivaFormatada: dataFinalEfetiva ? UtilDateTime.toFormatBrazil({ dateTime: dataFinalEfetiva }) : "",
        });

        editandoDatasEntregaFinal.value = false;

    } finally {

        salvandoDatasEntregaFinal.value = false;

    }

};

//====================================================================//
//==== Prepara Modal se Dados Originais Carregados ou Recarregados ===//
//==================== Watch => visualizandoDado =====================//
//====================================================================//

watch(()=> props?.visualizandoDado, async () => {

    if(props?.visualizandoDado == true){
        preparaModal();
    }

},{ immediate: true });

</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="props.visualizandoDado"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card class="c-modal">

                <BarraNavegacao
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :dado="dado"
                    :visualizandoDado="props.visualizandoDado"
                    :controlesDesativados="props.controlesDesativados"
                    @update:alteraVisualizandoDado="alteraVisualizandoDado"
                    @update:iniciaEdicaoDatasEntrega="iniciaEdicaoDatasEntregaFinal"
                ></BarraNavegacao>

                <DadoConteudo
                    :dado="dado"
                    :editandoDatasEntregaFinal="editandoDatasEntregaFinal"
                    :salvandoDatasEntregaFinal="salvandoDatasEntregaFinal"
                    :erroDatasEntregaFinal="erroDatasEntregaFinal"
                    @update:alteraItem="alteraItem"
                    @update:alteraAditivo="alteraAditivo"
                    @update:salvaDatasEntregaFinal="salvaDatasEntregaFinal"
                    @update:cancelaEdicaoDatasEntregaFinal="cancelaEdicaoDatasEntregaFinal"
                ></DadoConteudo>
            
            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

</style>